/* GENERATED FILE - do not edit. Run: node scripts/generate-phosphor-icons.mjs */
import type { JSX } from 'solid-js'
import { IconBase, type IconProps, type WeightRenderers } from './IconBase'

const renderers: WeightRenderers = {
  regular: (color: string): JSX.Element => (
    <g>
      <circle
        cx="128"
        cy="128"
        r="96"
        fill="none"
        stroke={color}
        stroke-miterlimit="10"
        stroke-width="16"
      />
      <line
        x1="160"
        y1="96"
        x2="96"
        y2="160"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
      <line
        x1="160"
        y1="160"
        x2="96"
        y2="96"
        fill="none"
        stroke={color}
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="16"
      />
    </g>
  ),
}

export const XCircle = (props: IconProps) => <IconBase {...props} renderers={renderers} />
